import React from 'react';
import cx from 'classnames';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, branch, renderNothing, withProps, withHandlers } from 'recompose';
import config from '../../../../config';
import { t } from '../../../../modules/infra/i18n';

import Modal from '../../../common/Modal';
import Spinner from '../../../common/Spinner';
import { activeShopWebreader, isApiReaderEnabledForShop } from '../../../auth/selectors';
import Http from '../../../http';
import { getProcessing } from '../../../register/tipping/selectors';
import { cancelWebreaderTransaction } from '../../../terminal/actions';
import { getIsProcessingExternalPayment } from '../../../register/webReader/selector';
import { getHasReaderPayment } from '../../../register/payment/reducer/payments/selectors';
import apiTerminal from '../../../terminal/ApiTerminal';

const WebReaderLoader = ({ cancel, cancellable, isProcessor, isSimulatedApiReader, simulatePayment }) => {
  const title = cancellable
    ? t('register:web_reader_loader.waiting_for_terminal')
    : t('register:web_reader_loader.processing');
  const className = cx({ 'c-modal__shadowed': isProcessor });
  const overlayClassName = cx({ 'u-bg-transparent': isProcessor });

  return (
    <Modal
      title={title}
      close={noop}
      className={className}
      overlayClassName={overlayClassName}
    >
      <div className="u-ph++ u-pv u-text-center">
        <Spinner showForContainerApp />
        <button
          display-if={isSimulatedApiReader}
          className="c-btn c-btn--primary u-mt+"
          data-automation-id="retry-button"
          type="button"
          onClick={simulatePayment}
        >
          {t('register:web_reader_loader.simulate_payment_button')}
        </button>
        <button
          className="c-btn c-btn--primary u-mt+"
          data-automation-id="retry-button"
          type="button"
          onClick={cancel}
          disabled={!cancellable}
        >
          {t('common:buttons.cancel')}
        </button>
      </div>
    </Modal>
  );
};

WebReaderLoader.propTypes = {
  isProcessor: PropTypes.bool,
  isSimulatedApiReader: PropTypes.bool,
  simulatePayment: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  cancellable: PropTypes.bool.isRequired,
};

WebReaderLoader.defaultProps = {
  isProcessor: false,
  isSimulatedApiReader: false,
};

export default compose(
  connect(
    state => ({
      cancellable: state.register.webReader.cancellable,
      isProcessingInternalPayment: getProcessing(state),
      isProcessingExternalPayment: getIsProcessingExternalPayment(state),
      isInternalReaderPayment: activeShopWebreader(state) && getHasReaderPayment(state),
      isExternalReaderPayment: activeShopWebreader(state),
      isRefund: state.register.webReader.webreaderStrategy === 'refund',
      readerId: apiTerminal.readerId,
      isApiReader: isApiReaderEnabledForShop(state),
    }),
    { cancel: cancelWebreaderTransaction }
  ),
  withProps(props => ({
    isProcessing: props.isProcessor ? props.isProcessingExternalPayment : props.isProcessingInternalPayment,
    isReaderPayment: props.isProcessor ? props.isExternalReaderPayment : props.isInternalReaderPayment,
    isSimulatedApiReader: props.isApiReader && !props.isRefund && config.terminalSimulatedMode,
  })),
  withHandlers({
    cancel: props => () => {
      const strategy = props.isRefund ? 'refund' : 'pay';
      props.cancel(strategy);
    },
    simulatePayment: props => () => {
      if (props.isSimulatedApiReader) {
        Http.post('/stripe-terminal/simulate-payment', { reader_id: props.readerId });
      }
    },
  }),
  branch(
    props => !props.isProcessing || !(props.isReaderPayment || props.isRefund),
    renderNothing,
  ),
)(WebReaderLoader);
